import React from 'react'
import Header from '../../../../Components/Header'
import Updatewarehouse from './Updatewarehouse'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
function UpdateWarehouseMaster() {
    const location = useLocation();
    const warehouseData = location.state;
    return (
        // <>
        //         <Header/>
        //         <div className="container-fluid maindiv pt-2">
        //             <Updatewarehouse warehouseData={warehouseData}/>
        //         </div>
        //     </>

        <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
				<title>Warehouse - Edit</title>
			</Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <Updatewarehouse warehouseData={warehouseData} />
            </div>
        </div>

    )
}

export default UpdateWarehouseMaster
